import * as React from "react";
function SvgCalendar(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 5.372h2v.973c0 .537.448.972 1 .972s1-.435 1-.972v-.973h6v.973c0 .537.448.972 1 .972s1-.435 1-.972v-.973h2v12.645H5V5.372zm12-1.945h4v14.59c0 1.074-.895 1.945-2 1.945H5c-1.105 0-2-.87-2-1.945V3.427h4V1.48h2v1.946h6V1.48h2v1.946zm-8 7.781V9.263H7v1.945h2zm0 1.945V15.1H7v-1.946h2zm4 1.946v-1.946h-2V15.1h2zm4-1.946V15.1h-2v-1.946h2zm0-1.945V9.263h-2v1.945h2zm-4-1.945v1.945h-2V9.263h2z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgCalendar);
export default ForwardRef;
